const CHUNK_LOAD_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /unable to preload css/i,
  /loading chunk [\w-]+ failed/i
]

export const CHUNK_RELOAD_STORAGE_KEY = 'johku_chunk_reload_at'
export const CHUNK_RELOAD_COOLDOWN_MS = 15_000

let reloadQueued = false

export function isChunkLoadError (error: unknown): boolean {
  if (error == null) {
    return false
  }
  if (typeof error === 'string') {
    return CHUNK_LOAD_PATTERNS.some(pattern => pattern.test(error))
  }
  if (typeof error !== 'object') {
    return false
  }
  const name = 'name' in error ? String(error.name) : ''
  if (name === 'ChunkLoadError' || name === 'VitePreloadError') {
    return true
  }
  const message = 'message' in error ? String(error.message) : String(error)
  return CHUNK_LOAD_PATTERNS.some(pattern => pattern.test(message))
}

export function reloadOnceOnChunkError (now = Date.now()): boolean {
  if (typeof window === 'undefined' || reloadQueued) {
    return false
  }
  try {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY) || 0)
    if (last && now - last < CHUNK_RELOAD_COOLDOWN_MS) {
      return false
    }
    sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, String(now))
  } catch {
    // sessionStorage can throw in private mode; still reload once this tick
  }
  reloadQueued = true
  window.location.reload()
  return true
}
